import React from "react";
import { MarkdownContent } from "utils/markdown/markdown-content";

export const CCPApp = () =>  <MarkdownContent path={require("../content/ccpapp.md")} title="California Notice at Collection and Privacy Notice" />;

